// import React, { Component, useContext, useState, useEffect, useMemo } from 'react'
import React from 'react'
import { Redirect } from 'react-router-dom'
import { PropTypes } from 'prop-types'

import auth from '../../components/common/Auth';

import { Card, Col, Container, Form, Row } from 'react-bootstrap'

import { PageHeaderStandar } from '../../components/common/PageHeaderStandar';

export const UserProfile = (props, context) => {
  
  const user = auth.getSessionUser();
              
  return (
    <div>
      <Container fluid>

        {/* Page header has Title and Subtite of the page */}
        <PageHeaderStandar title={context.t('Profile')} subtitle={context.t('User')} />

        <Card small="true" style={{ marginBottom: '20px'}}>
          <Form style={{ padding: "10px"}}>            
                <br/>
                <Row>
                <Col lg="12" className="pb-2">
                    <i className="material-icons">badge</i> {user.given_name}, {user.family_name}
                </Col>
                <Col lg="12" className="pb-1">
                    <i className="material-icons">email</i> {user.email}
                </Col>
                <Col lg="12" className="pb-1 ">
                    <i className="material-icons">local_phone</i> {user.phone_number}
                </Col>                
                <Col lg="12" className="pb-2">                    
                    <hr/>
                    <i className="material-icons">account_circle</i> {user.user_name}                    
                </Col>
                <Col lg="12" className="pb-2">
                    <i className="material-icons">fingerprint</i> {user.roles[0].name}
                </Col>
                <Col lg="12" className="pb-1">
                    <hr/>
                    <i className="material-icons">verified_user</i> {user.accounts[0].name}
                </Col>
                <Col lg="12" className="pb-1">
                    <i className="material-icons">email</i> {user.accounts[0].email}
                </Col>
                <Col lg="12" className="pb-1">
                    <i className="material-icons">local_phone</i> {user.accounts[0].phone_number}
                </Col>
                </Row>
                <br/>
                <small className="pull-right"> <i className="material-icons">access_time</i> {user.created_at}</small>
          </Form>
        </Card>
      </Container>
    </div>
  )
}

UserProfile.contextTypes = {
    t: PropTypes.func
}

export default UserProfile;

